<template>
  <div style="position: relative" class="model-card__local-body">
    <div class="d-flex justify-center" style="position: absolute; top: 0; left: 0; width: 100%"></div>
    <div class="three-wrapper">
      <div id="three"></div>
    </div>
  </div>
</template>

<script>
// TODO: Rename to SecureModelCard.vue

import LegacyApi from "../api/LegacyApi";
import AppModel from "../domain/AppModel";
import AppRenderer from "../domain/AppRenderer";

export default {
  props: {
    modelIndex: {
      type: String,
      default: "bear",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      cameraPosition: {
        x: 0.34462566143723866,
        y: 0.8573113065464888,
        z: 1.718044448155407,
        _x: -0.08861077948998768,
        _y: 0.5241708098872303,
        _z: -0.2821844891225064,
      },
      // cameraPosition: {
      //   x: -3.076866335667016,
      //   y: 1.4119841647550282,
      //   z: 2.304215680168056,
      //   _x: -3.570537418446888,
      //   _y: 0.7537560543818643,
      //   _z: 0.9054809456250822,
      // },
    };
  },
  async mounted() {
    // const { modelUrl } = (await BaseApi.fetchMyModelMetadata(this.modelIndex)) || {};

    const appModel = await (async () => {
      if (["squirrel", "tiger"].includes(this.modelIndex)) {
        const { modelUrl } = await LegacyApi.fetchMyModelMetadata(this.modelIndex);
        const gltf = await LegacyApi.fetchModel(modelUrl);
        const appModel = await AppModel.parse(gltf);
        return appModel;
      } else {
        const url = `/broadcast-resources/models/v5/${this.modelIndex}_v5.glb`;
        // const url = `demo_models/total.glb`;
        const appModel = await AppModel.load(url);
        return appModel;
      }
    })();

    // set size
    const parent = this.$el.querySelector("#three");
    const appRenderer = AppRenderer.create(appModel, { width: this.width, height: this.height }, this.cameraPosition);
    parent.appendChild(appRenderer.canvasEl);
    this.appRenderer = appRenderer;
  },
  methods: {},
};
</script>

<style scoped>
.model-card__local-body {
  width: fit-content;
  height: fit-content;
  /* background-color: red; */
}
</style>
